// src/components/RightPanel/ContentArea.js
import React from 'react';
import MapView from '../ContentViews/MapView';
import ExploreView from '../ContentViews/ExploreView';
import useContentViewStore from '../../contexts/useContentViewStore';
import useUserLocationStore from '../../contexts/useUserLocationStore';

const DEBUG = true; // Enable debug logs

const ContentArea = () => {
  const { currentView } = useContentViewStore();
  const { userSelectedCity } = useUserLocationStore();

  if (DEBUG) console.log("ContentArea - userSelectedCity:", userSelectedCity);

  return (
    <div style={{ display: 'flex', flexGrow: 1, flexDirection: 'column', height: '100%' }}>
      {currentView === 'Map' ? (
        <MapView userSelectedCity={userSelectedCity} /> // Pass userSelectedCity to MapView
      ) : (
        <ExploreView />
      )}
    </div>
  );
};

export default ContentArea;
